import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AccountService } from '../../../@core/services/account.service';

@Component({
  selector: 'dpay-verify-account.component',
  styleUrls: ['./verify-account.component.scss'],
  templateUrl: './verify-account.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyAccountComponent {
  email: string;
  token: string;
  status: string;
  loading: boolean;
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(protected service: AccountService,
    protected cd: ChangeDetectorRef,
    route: ActivatedRoute) {
    route.queryParams
      .subscribe(params => {
        const token = params['token'];
        this.loading = true;
        this.service.verifyToken(token).pipe(first())
          .subscribe({
            next: () => {
              this.status = 'Sua conta foi verificada com sucesso.';
              this.cd.detectChanges();
            },
            error: failures => {
              this.loading = false;
              failures.error.forEach((err: { errorMessage: string; }) => {
                this.errors.push(err.errorMessage);
              });

              this.cd.detectChanges();
            }
          });
      });
  }
}
